import { takeEvery, call, put } from 'redux-saga/effects';
import { dataRequest } from '../../../../../../common/reducers/objectCollection/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksService from '../../../../services/TasksService';
import {
  sendRequest,
  requestInProcess,
  requestFinished
} from '../../../../common/reducers/taskToggleChosenMarkForm';
import { sendRequestRefreshItem } from '../../../../../../common/reducers/_list/reducer';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';
import { sendGetAuthAccountDataRequest } from '../../../../../users/common/reducers/states/authAccount';

function* taskToggleChosenMarkFormSaga(reducerName, action) {
  try {
    yield put(requestInProcess(reducerName));
    const result = yield call(
      timeoutCall,
      TasksService.taskToggleMark,
      action.payload,
      2
    );
    if (result.status === 200) {
      yield put(sendGetAuthAccountDataRequest());
      yield put(sendRequestRefreshItem(reducerName, action.payload));
      yield put(
        clientNoticesActions.addClientNotice({
          type: 'success',
          message: result.data.message
        })
      );
      yield put(
        dataRequest(
          'tasksModule.collections.tasksToExecutorsCollection',
          action.payload
        )
      );
    }
    yield put(requestFinished(reducerName));
  } catch (error) {
    console.log(error);
  }
}

export default function createSaga(reducerName) {
  return [
    takeEvery(
      sendRequest(reducerName).type,
      taskToggleChosenMarkFormSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/forms/sagas/taskToggleChosenMarkFormSaga.js